<template>
    <v-btn class="btn btn-outline-primary text-center rounded-pill pa-0" icon @click="click(data)">
        <i class="fa fa-crosshairs ma-0 pa-0"></i>
    </v-btn>
</template>

<script>
export default {
    name: "useBtn",
    props: {
        data: {},
        name: {},
        click: {
            type: Function,
            default: () => {
            }
        }
    }
}
</script>

<style scoped>

</style>